const VN_TIMEZONE = "Asia/Ho_Chi_Minh";

const dateTimeFormatter = new Intl.DateTimeFormat("vi-VN", {
  timeZone: VN_TIMEZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hourCycle: "h23",
});

const dateFormatter = new Intl.DateTimeFormat("vi-VN", {
  timeZone: VN_TIMEZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

const timeFormatter = new Intl.DateTimeFormat("vi-VN", {
  timeZone: VN_TIMEZONE,
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hourCycle: "h23",
});

const dateTimeShortFormatter = new Intl.DateTimeFormat("vi-VN", {
  timeZone: VN_TIMEZONE,
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

const part = (parts: Intl.DateTimeFormatPart[], type: string) =>
  parts.find((p) => p.type === type)?.value ?? "";

export function formatDateTime(iso: string): string {
  const parts = dateTimeFormatter.formatToParts(new Date(iso));
  return `${part(parts, "day")}/${part(parts, "month")}/${part(parts, "year")} ${part(
    parts,
    "hour"
  )}:${part(parts, "minute")}:${part(parts, "second")}`;
}

export function formatDate(iso: string): string {
  const parts = dateFormatter.formatToParts(new Date(iso));
  return `${part(parts, "day")}/${part(parts, "month")}/${part(parts, "year")}`;
}

export function formatDateTimeShort(iso: string): string {
  const parts = dateTimeShortFormatter.formatToParts(new Date(iso));
  return `${part(parts, "day")}/${part(parts, "month")} ${part(parts, "hour")}:${part(
    parts,
    "minute"
  )}`;
}

export function toDateInput(iso: string): string {
  const parts = dateFormatter.formatToParts(new Date(iso));
  return `${part(parts, "year")}-${part(parts, "month")}-${part(parts, "day")}`;
}

export function todayInVn(): string {
  const parts = dateFormatter.formatToParts(new Date());
  return `${part(parts, "year")}-${part(parts, "month")}-${part(parts, "day")}`;
}

export function nowTimeInVn(): { hh: string; mm: string; ss: string } {
  const parts = timeFormatter.formatToParts(new Date());
  return {
    hh: part(parts, "hour"),
    mm: part(parts, "minute"),
    ss: part(parts, "second"),
  };
}

export function startOfTodayInVnIso(): string {
  return new Date(`${todayInVn()}T00:00:00+07:00`).toISOString();
}